module.exports = __webpack_public_path__ + "media/word-submit.b6a8414e.mp3";